// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e8689f5c","453":"98f2949c","667":"d0532ac5","946":"4b502810"}[chunkId] + ".chunk.js";
};